import { render, staticRenderFns } from "./DriverDetailAssignments.vue?vue&type=template&id=592bc816&scoped=true&"
import script from "./DriverDetailAssignments.vue?vue&type=script&lang=js&"
export * from "./DriverDetailAssignments.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailAssignments.vue?vue&type=style&index=0&id=592bc816&lang=scss&scoped=true&"
import style1 from "./DriverDetailAssignments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592bc816",
  null
  
)

export default component.exports